import { useState, useRef, useEffect } from "react";
import { sendRequest } from '../../hooks/requests/useRequest';
import debounce from "lodash.debounce";

export const useGlobalSearchAdmission = (id_patient, checkTypeClient) => {
  const [value, setValue] = useState("");
  const [resultsSearch, setResultsSearch] = useState([]);
  const [loading, setLoading] = useState(false);
  const [overlayPanel, setOverlayPanel] = useState(null);
  const [pendingSelection, setPendingSelection] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const urlHelen = localStorage.getItem("url_helen");
  const autoCompleteRef = useRef(null);
  const lastQueryRef = useRef("");

  const [counts, setCounts] = useState({
    patients: 0,
    doctors: 0,
    exams: 0,
    profiles: 0
  });

  const debouncedSearch = useRef(
    debounce(async (query) => {
      lastQueryRef.current = query;

      if (!query || query.length < 3) {
        setLoading(false);

        setResultsSearch([
          {
            isMessage: true,
            message: "Escribe al menos 3 caracteres para buscar"
          }
        ]);

        setCounts({
          patients: 0,
          doctors: 0,
          exams: 0,
          profiles: 0
        });

        return;
      }
      setLoading(true);

      try {

        const response = await sendRequest(
          { method: 'GET' },
          // `SearchGlobal/GlobalSearch?search=${query}`
          `SearchGlobal/GlobalSearch?search=${encodeURIComponent(query)}&isWorkOrder=true`

        );
        if (lastQueryRef.current !== query) return;

        const data = response?.data;

      
        let patients = data?.patients || [];
        let doctors = data?.doctors || [];
        let estudios = data?.estudios || [];

        //AGREGADO PARA QUE BUSQUE POR CLAVE DEL EXAMEN PRIMERO
        const searchText = query.trim().toUpperCase();

        const isStudyCodeSearch = estudios.some(item => {
          const clean = item.component
            .replace("[EXAMEN]", "")
            .replace("[PERFIL]", "")
            .trim();

          const abbreviation = clean.split(" - ")[0]?.toUpperCase();

          return abbreviation?.trim() === searchText.trim();
        });
          
        if (isStudyCodeSearch) {
          patients = [];
          doctors = [];
        }
        
        const exams = estudios.filter(e => !e.component.includes("[PERFIL]"));
        const profiles = estudios.filter(e => e.component.includes("[PERFIL]"));

        const isAllEmpty =
          patients.length === 0 &&
          doctors.length === 0 &&
          exams.length === 0 &&
          profiles.length === 0;

        if (isAllEmpty) {
          setResultsSearch([
            {
              isMessage: true,
              message: `No hay resultados para "${query}"`
            }
          ]);

          setCounts({
            patients: 0,
            doctors: 0,
            exams: 0,
            profiles: 0
          });

          setLoading(false);
          return;
        }

        setCounts({
          patients: patients.length,
          doctors: doctors.length,
          exams: exams.length,
          profiles: profiles.length
        });

        let flat = [];

        // SI YA HAY PACIENTE SELECCIONADO
        if (id_patient !== 0) {

          // DOCTORES
          if (doctors.length > 0) {
            flat.push({ isGroup: true, group_name: "Doctores" });

            doctors.forEach(item => {
              flat.push({
                ...item,
                type: "doctor",
                isGroup: false
              });
            });
          }

          // ESTUDIOS
          if (estudios.length > 0) {
            flat.push({ isGroup: true, group_name: "Estudios" });

            estudios.forEach(item => {
              const isProfile = item.component.includes("[PERFIL]");

              flat.push({
                ...item,
                type: isProfile ? "profile" : "exam",
                isGroup: false
              });
            });
          }

          // PACIENTES AL FINAL
          if (patients.length > 0) {
            flat.push({ isGroup: true, group_name: "Pacientes" });

            patients.forEach(item => {
              flat.push({
                ...item,
                type: "patient",
                isGroup: false
              });
            });
          }

        } else {

          // ORDEN NORMAL
          if (patients.length > 0) {
            flat.push({ isGroup: true, group_name: "Pacientes" });

            patients.forEach(item => {
              flat.push({
                ...item,
                type: "patient",
                isGroup: false
              });
            });
          }

          if (doctors.length > 0) {
            flat.push({ isGroup: true, group_name: "Doctores" });

            doctors.forEach(item => {
              flat.push({
                ...item,
                type: "doctor",
                isGroup: false
              });
            });
          }

          if (estudios.length > 0) {
            flat.push({ isGroup: true, group_name: "Estudios" });

            estudios.forEach(item => {
              const isProfile = item.component.includes("[PERFIL]");

              flat.push({
                ...item,
                type: isProfile ? "profile" : "exam",
                isGroup: false
              });
            });
          }
        }

        setResultsSearch(flat);
        setLoading(false);

      } catch (error) {
        if (lastQueryRef.current !== query) return;
        console.error(error);

        setResultsSearch([
          {
            isMessage: true,
            message: "Error al buscar, intenta nuevamente"
          }
        ]);

        setLoading(false);

        setCounts({
          patients: 0,
          doctors: 0,
          exams: 0,
          profiles: 0
        });
      }

    }, 300)
  ).current;

  const searchGlobal = (e) => {
    const query = e?.query ?? value;
    debouncedSearch(query);
  };

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);


  const parsePatient = (text) => {
    const parts = text.split(" - ");

    return {
      nombre: parts[0],
      edad: parts.find(p => p.includes("Edad"))?.replace("Edad: ", "") || "",
      sexo: parts.find(p => p.includes("Sexo"))?.replace("Sexo: ", "").toLowerCase() || "",
      birthday: parts.find(p => p.includes("F. Nacimiento"))?.replace("F. Nacimiento:", "") || ""
    };
  };

  const parseExamProfile = (text) => {
    const isProfile = text.includes("[PERFIL]");

    const clean = text
      .replace("[PERFIL]", "")
      .replace("[EXAMEN]", "")
      .trim();

    const parts = clean.split(" - ");

    return {
      type: isProfile ? "PERFIL" : "EXAMEN",
      abbreviation: parts[0] || "",
      name: parts.slice(1).join(" - ") || ""
    };
  };


  const parseDoctor = (text) => {
    const parts = text.split(" - ");

    return {
      nombre: parts[0],
      codigo: parts.find(p => p.includes("Codigo Doctor"))?.replace("Codigo Doctor: ", "") || "",
      especialidad: parts.find(p => p.includes("Especialidad"))?.replace("Especialidad: ", "") || "",
      ots: parts.find(p => p.includes("OTS"))?.replace("Num: OTS: ", "") || "0"
    };
  };



  const syncOverlayPanel = () => {
    const overlay = autoCompleteRef.current?.getOverlay?.() || null;
    setOverlayPanel(overlay);
  };



  useEffect(() => {
    if (showConfirm && autoCompleteRef.current) {
      setTimeout(() => {
        autoCompleteRef.current.show();
      }, 0);
    }
  }, [showConfirm]);

  const resetSearch = () => {
      setValue("");
      setResultsSearch([]);
      setPendingSelection(null);
      setShowConfirm(false);
      setOverlayPanel(null);

      lastQueryRef.current = "";

      debouncedSearch.cancel();

      if (
          autoCompleteRef.current &&
          autoCompleteRef.current.hide
      ) {
          autoCompleteRef.current.hide();
      }
  };
    
  return {
    value,
    setValue,
    resultsSearch,
    searchGlobal,
    counts,
    loading,
    setPendingSelection,
    pendingSelection,
    setShowConfirm,
    showConfirm,
    parsePatient,
    parseDoctor,
    parseExamProfile,
    autoCompleteRef,
    syncOverlayPanel,
    overlayPanel,
    setOverlayPanel,
    setResultsSearch,
    resetSearch,
    checkTypeClient
  };
};